import { render, staticRenderFns } from "./CreateCampaignSetupsView.vue?vue&type=template&id=cf81c992"
import script from "./CreateCampaignSetupsView.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSetupsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports